import request from './request'

/**
 * Get image proxy URL
 * @param {string} url - Original image URL
 * @returns {Promise} Promise containing the proxied image URL
 */
export const getProxyImageUrl = (url) => {
  return request({
    url: '/api/image-proxy',
    method: 'get',
    params: { url }
  })
}
